export default function({ baseModule, serviceAPI }) {
  return {
    ...baseModule.actions,
    async initCurrent({ commit, getters }, id) {
      if (getters.currents.findIndex((el) => el.id === id) < 0) {
        commit('SET_CURRENT_REQUEST', id);
        return serviceAPI.getCurrent(id).then((newCurrent) => {
          commit('ADD_CURRENT_SUCCESS', { id, newCurrent });
        });
      }
      return null;
    },
    setCurrentActive({ commit, dispatch }, item) {
      dispatch('initCurrent', item.id);
      commit('SET_CURRENT_ACTIVE', item);
      dispatch(
        'boilerplate/setModalOpened',
        { component: 'RequestDialog' },
        { root: true }
      );
    },
    setCurrentInactive({ commit }) {
      commit('CLEAR_ACTIVE');
    },
    removeCurrent({ commit }, id) {
      commit('REMOVE_CURRENT', id);
    },
    refreshCurrent({ dispatch }, id) {
      dispatch('removeCurrent', id);
      dispatch('initCurrent', id);
    },
  };
}
